import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

export class SpotlightEntity extends BaseEntityClass {
  constructor() {
    super();
    this.type = "spotlight";
    this.entity_version = 2;
  }
}
